


































import { defineComponent, reactive, ref } from "@vue/composition-api";
import ResultSticker from "@/components/vehicleCategoryWizard/steps/results/resultSticker/ResultSticker.vue";
import StepMaxPerson from "@/components/vehicleCategoryWizard/steps/StepMaxPerson.vue";
import StepMaxWeight from "@/components/vehicleCategoryWizard/steps/StepMaxWeight.vue";
import { stickerD1, stickerD2 } from "@/core/utils/vehicle";

export default defineComponent({
  name: "CamperVan",
  components: {
    ResultSticker,
    StepMaxPerson,
    StepMaxWeight,
  },
  setup(props, { emit }) {
    const stepHistory = reactive<string[]>(["maxPerson"]);
    const activeStep = ref("maxPerson");
    const selectionChanged = (value: string) => {
      activeStep.value = value;
      if (stepHistory[stepHistory.length - 1] !== value) {
        stepHistory.push(value);
      }
    };
    const backToCategoryStep = () => {
      emit("backToCategorySelector");
    };
    const prevStep = () => {
      if (stepHistory.length) {
        stepHistory.pop();
        activeStep.value = stepHistory[stepHistory.length - 1];
      }
    };
    const closeDialog = () => {
      emit("closeDialog");
    };
    return {
      activeStep,
      selectionChanged,
      backToCategoryStep,
      closeDialog,
      prevStep,
      stickerD1,
      stickerD2,
    };
  },
});
